// action - customization reducer
export const SET_MENU = "@customization/SET_MENU";
export const MENU_TOGGLE = "@customization/MENU_TOGGLE";
export const MENU_OPEN = "@customization/MENU_OPEN";
export const SET_FONT_FAMILY = "@customization/SET_FONT_FAMILY";
export const SET_BORDER_RADIUS = "@customization/SET_BORDER_RADIUS";
export const SET_CLUSTER_MENU = "@customization/SET_CLUSTER_MENU";

// action - dashboardSlice reducer
// export const SET_DATE_RANGES = '@DashboardPersist/setDateRanges';
export const SET_DATE_RANGES = "@DashboardSlice/setDateRanges";


// Update Data Screen Events
export const FORCE_RELOAD_UPDATE_DATA = "FORCE_RELOAD_UPDATE_DATA";
export const TICKER_APPROVE_UPDATE_DATA = "TICKER_APPROVE_UPDATE_DATA";
export const TICKER_DISAPPROVE_UPDATE_DATA = "TICKER_DISAPPROVE_UPDATE_DATA";
// Clustered Screen Events
export const WEB_SEARCH_CLUSTERED = "WEB_SEARCH_CLUSTERED";
export const APPROVE_ROW_CLUSTERED = "APPROVE_ROW_CLUSTERED";
export const ADD_ROW_CLUSTERED = "ADD_ROW_CLUSTERED";
export const COPY_ROW_CLUSTERED = "COPY_ROW_CLUSTERED";
export const EDIT_ROW_CLUSTERED = "EDIT_ROW_CLUSTERED";
export const SAVE_ROW_CLUSTERED = "SAVE_ROW_CLUSTERED";
export const SAVE_APPROVE_ROW_CLUSTERED = "SAVE_APPROVE_ROW_CLUSTERED";
export const DELETE_ROW_CLUSTERED = "DELETE_ROW_CLUSTERED";
export const FILL_ALL_FIELDS_CLUSTERED = "FILL_ALL_FIELDS_CLUSTERED";
// Exact Screen Events
export const APPROVE_ROW_EXACT = "APPROVE_ROW_EXACT";
export const EDIT_ROW_EXACT = "EDIT_ROW_EXACT";
export const SAVE_ROW_EXACT = "SAVE_ROW_EXACT";
export const SAVE_APPROVE_ROW_EXACT = "SAVE_APPROVE_ROW_EXACT";
export const DISCARD_CHANGES_EXACT = "DISCARD_CHANGES_EXACT";
// Approved Data Screen Events
export const EDIT_ROW_APPROVED = "EDIT_ROW_APPROVED";
export const SAVE_ROW_APPROVED = "SAVE_ROW_APPROVED";
export const DISCARD_CHANGES_APPROVED = "DISCARD_CHANGES_APPROVED";
// Current Mapping Screen Events
export const SEARCH_CURRENT_MAPPING = "SEARCH_CURRENT_MAPPING";
